import { NextSeo } from 'next-seo';
import React from 'react';

import { LandingPage } from '../../components/landing-page/LandingPage';
import { PageLayout } from '../../components/page-layout';

const ExpertsPage = () => {
  return (
    <PageLayout
      authWall={false}
      bodyPaddingBottom={0}
      includeFooter={false}
      includeHeader={false}
    >
      <NextSeo
        title={`Experts`}
        description={
          'Your knowledge of the outdoor industry is valuable. Novices and fellow experts alike value input and advice when shopping for expensive and possibly lifesaving gear. Monetize your expertise, get discounts on gear, and join the community.'
        }
        openGraph={{
          url: `https://www.outdoorly.com/experts`,
          title: 'Experts',
          description:
            'Your knowledge of the outdoor industry is valuable. Novices and fellow experts alike value input and advice when shopping for expensive and possibly lifesaving gear. Monetize your expertise, get discounts on gear, and join the community.',
          site_name: 'Outdoorly',
        }}
      />
      <LandingPage />
    </PageLayout>
  );
};

ExpertsPage.propTypes = {};

export default ExpertsPage;
